import { Component, Input } from '@angular/core';
import { AppConfigService } from '../../../app-config.service';

@Component({
  selector: 'app-progress-bar',
  templateUrl: './progress-bar.component.html',
  styleUrls: ['./progress-bar.component.scss'],
  standalone: false
})
export class ProgressBarComponent {
  @Input() currentValue = 0;

  constructor(private readonly _appConfig: AppConfigService) {}

  get progressValue() {
    return this.currentValue + '%';
  }

  get suffix() {
    return this._appConfig.langue === 'fr' ? ' %' : '%';
  }

  get roundedCurrentValue(): number {
    return Math.round(this.currentValue);
  }
}
